module.exports = __webpack_public_path__ + "media/images/illustrations/corner-1-dfdb6c51fda7357ab0fd28af8882094f.png";